import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { mySqlQueryListStaleTimeMs } from "../config";
import { mySqlQueryListRepo } from "../repo/mySqlQueryListRepo";
import { buildMySqlQueryListParams, buildMySqlQueryListQueryKey } from "../service/mySqlQueryListService";
import type { MySqlQueryListItem, MySqlQueryListPage, MySqlQueryListParams, QueryFormState } from "../types";

type UseMySqlQueryListQueryOptions = {
  page: number;
  pageSize: number;
  filters: QueryFormState;
  queryRootKey?: readonly string[];
  fetchList?: (params: MySqlQueryListParams) => Promise<MySqlQueryListPage>;
};

/** 统一封装 MySQL 列表查询。 */
export function useMySqlQueryListQuery({
  page,
  pageSize,
  filters,
  queryRootKey,
  fetchList,
}: UseMySqlQueryListQueryOptions) {
  const requestState = useMemo(
    () => ({
      page,
      pageSize,
      filters,
    }),
    [filters, page, pageSize],
  );

  const query = useQuery({
    queryKey: buildMySqlQueryListQueryKey(requestState, queryRootKey),
    queryFn: () => (fetchList ?? mySqlQueryListRepo.fetchList)(buildMySqlQueryListParams(requestState)),
    retry: false,
    staleTime: mySqlQueryListStaleTimeMs,
    refetchOnWindowFocus: false,
  });

  return {
    ...query,
    items: query.data?.items ?? ([] as MySqlQueryListItem[]),
    total: query.data?.total ?? 0,
  };
}
